export default __webpack_public_path__ + "static/media/header-dropdown-body.60217d7f.png";